import React, { useState, useContext, useEffect } from 'react'
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';

import { OptionsContext } from '../../contexts/OptionsContext';

import formatUrlTitle from '../../helpers/formatUrlTitle'

import './CMSForm.css'
window.Buffer = window.Buffer || require("buffer").Buffer;


const CMSForm = ({ closeForm, initialData }) => {
  const { createTag, editTag } = useContext(OptionsContext)

  const [inputData, setInputData] = useState({
    name: '',
    url_title: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {

      setInputData({
        ...initialData,
      })
    }
  }, [initialData])


  function handleChange(e) {
    const { name, value } = e.target;

    setInputData({
      ...inputData,
      [name]: value,
      ...name === 'name' && { url_title: formatUrlTitle(value.replace(/[^a-zA-Z ]/g, "")) }
    });

  }

  function handleCloseForm(e) {
    // mousedown (not click): a failed save unmounts the spinner under the cursor,
    // and the leftover click would otherwise hit this overlay and dismiss the form.
    if (isSubmitting) return
    if (e.target === e.currentTarget) closeForm()
  }

  async function handleClick() {
    if (!inputData.name || !inputData.url_title ) {
      setError('Please fill out all required fields.')
      return
    }

    setError('')
    setIsSubmitting(true)
    try {
      let data = {
        ...inputData,
      }

      if (initialData && Object.keys(initialData).length > 0) {
        await editTag(initialData._id, data)
      } else {
        await createTag(data)
      }
      closeForm()
    } catch (error) {
      console.error('Error submitting form:', error)
      const errorData = error.response?.data
      setError(errorData?.errors?.length ? errorData.errors.join(' ') : errorData?.msg || errorData?.message || 'Failed to save tag.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div onMouseDown={handleCloseForm} className="modal-overlay">
      <div className="manage-facility-form">
        <h3 className="manage-facility-form-title">
          {initialData && Object.keys(initialData).length > 0 ? 'Edit Tag' : 'Create Tag'}
        </h3>

        <label htmlFor="title">Name</label>
        <InputBase className='manger-facility-input' value={inputData.name} onChange={(e) => handleChange(e)} type="text" name="name" id="name" placeholder='Name' />

        <label htmlFor="title">Url Title</label>
        <InputBase className='manger-facility-input' value={inputData.url_title} onChange={(e) => handleChange(e)} type="text" name="url_title" id="url_title" placeholder='Url Title' />

   
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Button className='manger-facility-btn' disabled={isSubmitting} onClick={() => handleClick()}>{isSubmitting ? 'Submitting...' : 'Submit'}</Button>
        </div>
        {error && <p style={{ textAlign: 'center', color: '#E23844' }}>{error}</p>}
      </div>
    </div>
  )
}

export default CMSForm




